import pkg from "../../package.json";

/**
 * Etiqueta de version mostrada en el dialogo About. Se deriva de la
 * version declarada en package.json para no duplicar el numero.
 */
export const APP_VERSION = pkg.version;
export const APP_VERSION_LABEL = `v${pkg.version}`;
